import { QueryClient, QueryFunction } from '@tanstack/react-query';
import serviceFetcherToTQFunction from 'services/tq-adapter/serviceFetcherToTQFunction';
import serviceOptionsToTQOptions from 'services/tq-adapter/serviceOptionsToTQOptions';
import serviceToTQKey from 'services/tq-adapter/serviceToTQKey';
import { OneServiceNoParams } from 'types/services/services';

/**
 * Convert a service without params to tanstack query interface
 * @param service the service to use
 * @param queryClient the tanstack query client
 * @returns the interface for tanstack query
 */
const serviceNoParamsToTQInterface = <Data>(service: OneServiceNoParams<Data>, queryClient: QueryClient) => {
  const queryKey = serviceToTQKey(service) as readonly unknown[];
  const queryFn = serviceFetcherToTQFunction(service, queryClient) as QueryFunction<Data, readonly unknown[]>;

  const options = serviceOptionsToTQOptions(service.options);

  return { queryKey, queryFn, ...options };
};

export default serviceNoParamsToTQInterface;
